export default __webpack_public_path__ + "static/media/nft_image_0.45ed8829.png";